import React from 'react';
import styled from '@emotion/styled';
import { Card, Badge, Modal } from 'react-bootstrap';
export const ChartCard = styled(Card)`
    margin-bottom: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;
    transition:
        transform 0.2s ease-in-out,
        box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }

    .chart-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
        background: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
    }

    .chart-body {
        padding: 15px;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: #f8f9fa;
        }
    }
`;

export const ZoomModal = styled(Modal)`
    .modal-dialog {
        max-width: 95vw;
        width: 95vw;
        margin: 2.5vh auto;
    }

    .modal-content {
        height: 100%;
        border-radius: 15px;
        overflow: hidden;
    }

    .modal-body {
        padding: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
`;

export const ChartContainer = styled.div`
    flex: 1;
    padding: 20px;
    background: white;

    .zoom-chart {
        height: 100%;
        width: 100%;
    }
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;

    .header-content {
        flex: 1;

        h4 {
            margin: 0;
            color: #2c3e50;
        }

        .chart-meta {
            color: #6c757d;
            font-size: 0.9rem;
            margin-top: 5px;
        }
    }

    .header-actions {
        display: flex;
        gap: 10px;
        align-items: center;
    }
`;

export const ValidationBadge = styled(Badge)`
    margin-left: 10px;
    font-size: 0.8rem;
    padding: 5px 8px;
`;
